<template>
  <div class="card-container">
    <div class="head" @click="toggleCollapse">
      <div v-if="title" class="title">
        <div style="display: flex; align-items: center;">
          <div>{{ title }}</div>
          <div v-if="showOptional" class="optional">{{ $t('message.common.optional') }}</div>
        </div>
        <div class="action">
          <slot name="action"></slot>
        </div>
      </div>
      <slot v-else name="header"></slot>

      <i v-if="collapsible" class="collapse-icon el-icon-arrow-right" :class="{ 'is-collapsed': !isCollapsed && collapsible }"></i>
    </div>
    <div class="main" :class="{ 'is-collapsed': isCollapsed && collapsible }">
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rhcn-card-v2',
  props: {
    /** 标题 */
    title: {
      type: String,
      default: '',
    },
    /** 是否显示选填 */
    showOptional: {
      type: Boolean,
      default: false,
    },
    /** 是否启用折叠效果 */
    collapsible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCollapsed: this.collapsible,
    };
  },
  methods: {
    toggleCollapse() {
      if (this.collapsible) {
        this.isCollapsed = this.collapsible ? !this.isCollapsed : this.isCollapsed;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-container {
  padding: 24px;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #EFEFF4;
}
.head {
  width: 100%;
  padding-bottom: 17px;
  border-bottom: 1px solid #EFEFF4;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    font-family: OPPOSans, OPPOSans;
    font-weight: bold;
    font-size: 20px;
    color: #1A202C;
    line-height: 30px;
    text-align: left;
    font-style: normal;
    text-transform: none;

    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;

    .optional {
      margin-left: 24px;
      padding: 2px 8px;
      font-family: Open Sans, Open Sans;
      font-weight: 400;
      font-size: 12px;
      color: #027A48;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      background: #ECFDF3;
      border-radius: 20px 20px 20px 20px;
    }
  }
  .collapse-icon {
    width: 16px;
    height: 16px;
    position: relative;
    transition: transform 0.5s;
    font-weight: bold;

    &.is-collapsed {
      transform: rotate(90deg);
    }
  }
}

.main {
  margin-top: 24px;
  max-height: 1000px; /* 设定一个足够大的值以容纳内容 */
  overflow: hidden;
  transition: max-height 0.5s ease-in-out;
  &.is-collapsed {
    max-height: 0;
    transition: max-height 0.4s; /* 立即收起 */
  }
}
</style>
